interface APIWorkerCommon {
    id: number
    status: "INVITED" | "ACTIVE" | "INACTIVE"
    invited: string
    accepted: string | null
    created: string
    groupsTotal: number
}

interface APIUserWorker extends APIWorkerCommon {
    type: "USER"
    userId: number
    userEmail: string
    userUsername: string
}

interface APIBotWorker extends APIWorkerCommon {
    type: "BOT"
}

interface APIAIWorker extends APIWorkerCommon {
    type: "AI"
}

interface APICrowdWorker extends APIWorkerCommon {
    type: "CROWD"
}

export type APIWorker =
    | APIUserWorker
    | APICrowdWorker
    | APIBotWorker
    | APIAIWorker

export function getWorkerId(worker: APIWorker): string {
    return String(worker.id)
}

export function getNumericWorkerId(worker: APIWorker): number {
    return worker.id
}

export function getWorkerDisplayText(worker: APIWorker): string {
    switch (worker.type) {
        case "USER":
            return worker.userEmail
        default:
            return worker.type
    }
}
